/** util to check is a list of roles conatins an admin role */
export const hasAdmin = (roles = []) => {
  return roles.some((item) => item.role === "admin")
}

export const hasAny = (ctxRoles = [], allowRoles = []) =>
  ctxRoles.find(({ role }) => {
    return allowRoles.includes(role)
  }) != null
